import React from "react";
import IFormikProps from "../interfaces/others/IFormikProps";
import CustomInput from "../components/formik/CustomInput.tsx";
import PartnersAutocomplete from "../components/formik/PartnersAutocomplete.tsx";
import BranchAutocomplete from "../components/common/BranchAutocomplete.tsx";
const ReporteRelojChecadorForm = ({
  formik,
  branches,
  disabled = false,
  handleDownload,
  availableDownload = false,
}: IFormikProps & {
  branches: any[];
  disabled?: boolean;
  handleDownload: () => void;
  availableDownload?: boolean;
}) => {
  const actionsWrapStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginTop: "4px",
    marginBottom: 0,
    padding: "4px 0 0",
  };

  const baseBtnStyle: React.CSSProperties = {
    minWidth: "148px",
    padding: "11px 28px",
    borderRadius: "999px",
    border: "none",
    fontSize: "0.9rem",
    fontWeight: 600,
    letterSpacing: "0.02em",
    cursor: "pointer",
    transition: "transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease",
  };

  const searchBtnStyle: React.CSSProperties = {
    ...baseBtnStyle,
    background: "linear-gradient(135deg, #50B7C0 0%, #3d9aa3 100%)",
    color: "#ffffff",
    boxShadow: "0 4px 14px rgba(80, 183, 192, 0.35)",
  };

  const downloadBtnStyle: React.CSSProperties = {
    ...baseBtnStyle,
    background: "#ffffff",
    color: "#334155",
    border: "2px solid #cbd5e1",
    boxShadow: "0 2px 8px rgba(15, 23, 42, 0.06)",
  };

  return (
    <form
      className="reporte-reloj-checador-form"
      onSubmit={formik.handleSubmit}
      noValidate
    >
      <div className="reporte-reloj-fields">
      <BranchAutocomplete
        branches={[...branches, { id: 0, name: "Todas" }]}
        value={formik.values.branch}
        onChange={(branchId) => {
          formik.setFieldValue("branch", branchId);
          formik.setFieldTouched("branch", true, false);
        }}
        disabled={disabled}
        label="Sucursal"
        placeholder="Buscar sucursal..."
        clearValue={0}
      />

      <PartnersAutocomplete
        label="Chilito"
        field="partner"
        formik={formik}
        sm={4}
        smLabel={4}
      />

      <CustomInput
        formik={formik}
        field="start"
        label="Fecha inicio"
        type="date"
        sm={4}
        smLabel={4}
      />
      <CustomInput
        formik={formik}
        field="end"
        label="Fecha fin"
        type="date"
        sm={4}
        smLabel={4}
        classInput="mb-1"
      />
      </div>

      <div className="reporte-reloj-actions" style={actionsWrapStyle}>
        <button
          type="submit"
          style={searchBtnStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-1px)";
            e.currentTarget.style.boxShadow =
              "0 6px 18px rgba(80, 183, 192, 0.45)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow =
              "0 4px 14px rgba(80, 183, 192, 0.35)";
          }}
        >
          <i className="fa-solid fa-magnifying-glass me-2" />
          Buscar
        </button>
        {availableDownload && (
          <button
            type="button"
            style={downloadBtnStyle}
            onClick={() => handleDownload()}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-1px)";
              e.currentTarget.style.borderColor = "#50B7C0";
              e.currentTarget.style.color = "#0f766e";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.borderColor = "#cbd5e1";
              e.currentTarget.style.color = "#334155";
            }}
          >
            <i className="fa-solid fa-file-arrow-down me-2" />
            Descargar
          </button>
        )}
      </div>
    </form>
  );
};

export default ReporteRelojChecadorForm;
